// extracted by mini-css-extract-plugin
export var lockIcon = "Verification-module--lockIcon--033ca";
export var pageMessageText = "Verification-module--pageMessageText--ea149";